import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import TransactionsPage from "../../components/Transactions Page/TransactionsPage";

const TransactionsList = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title="Payments And Transactions" />
                <TransactionsPage />
            </MasterLayout>
        </>
    );
};

export default TransactionsList;
